import { PostsBlock, FeaturedBlock } from "components/blog";
import * as React from 'react';
export default {
  PostsBlock,
  FeaturedBlock,
  React
};